import { ApolloClient, InMemoryCache, createHttpLink, from } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { config } from '../config/config';
import { apolloErrorLink } from '../monitoring/apolloErrorLink';

const httpLink = createHttpLink({
  uri: config.graphqlUrl,
});

const authLink = setContext((_, { headers }) => {
  const userId = localStorage.getItem('userId');
  return {
    headers: {
      ...headers,
      authorization: userId ? `Bearer ${userId}` : '',
      'Content-Type': 'application/json',
      'x-api-key': config.graphqlApiKey,
    },
  };
});

export const client = new ApolloClient({
  link: from([apolloErrorLink, authLink, httpLink]),
  cache: new InMemoryCache({
    typePolicies: {
      // Backend allows same question id in multiple inventories.
      // Use composite key to prevent entity collisions in Apollo cache.
      Question: {
        keyFields: ['id', 'inventory_id'],
      },
    },
  }),
});
